/* @flow */

import React from 'react';
import styled from '@emotion/styled';
import { padding } from 'polished';
import classnames from 'classnames';

import Column from 'app/components/commons/Column';

type Props = {
  children?: React.Node,
  onClick?: () => void,
  width?: number,
  largeScreenWidth?: number,
  size?: number,
  narrow?: boolean,
  sortDir?: 'asc' | 'desc'
};

const defaultProps = {
  narrow: false,
  width: undefined,
  largeScreenWidth: undefined,
  children: null,
  size: undefined,
  onClick: undefined,
  sortDir: undefined
};

const StyledColumn = styled(Column)(
  {
    paddingTop: `0 !important`,
    paddingBottom: `0 !important`
  },
  ({ narrow }) => (narrow ? { flexGrow: '0 !important' } : {})
);

const Cell = styled.button(
  ({ theme }) => ({
    alignItems: 'center',
    border: 0,
    display: 'flex',
    ...padding(theme.spacing.tiny, 0),
    textTransform: 'uppercase'
  }),
  ({ width }) => (width ? { width } : {}),
  ({ theme, largeScreenWidth }) =>
    largeScreenWidth ? { [theme.mediaQuery.desktopLargeOnly]: { width: largeScreenWidth } } : {}
);

const SortIndicatorWrapper = styled.div({
  paddingLeft: 3
});

const TableHeadCell = ({
  children,
  narrow,
  onClick,
  width,
  largeScreenWidth,
  size,
  sortDir
}: Props) => {
  return (
    <StyledColumn
      narrow={narrow}
      className={classnames({ 'is-narrow': narrow }, size ? `is-${size}` : '')}
    >
      <Cell onClick={onClick} width={width} largeScreenWidth={largeScreenWidth}>
        {children}
        <SortIndicatorWrapper>
          {sortDir && (
            <span
              className={
                {
                  asc: 'ion-arrow-up-b',
                  desc: 'ion-arrow-down-b'
                }[sortDir]
              }
            />
          )}
        </SortIndicatorWrapper>
      </Cell>
    </StyledColumn>
  );
};

TableHeadCell.defaultProps = defaultProps;

export default TableHeadCell;
